import {IOnChanges, IOnChangesObject} from "angular";
import {PricingInstruction} from "../../../../orders/models/PricingInstruction";

export const TradePricingInstruction = "tfTradePricingInstruction";

export function tradePricingInstruction() {
    return {
        template,
        bindings: {
            pricingInstruction: "<",
            onChange: "&"
        },
        controller: TradePricingInstructionController,
        controllerAs: "ctrl"
    };
}

export class TradePricingInstructionController implements IOnChanges {
    public readonly onChange: Function;
    public pricingInstruction: PricingInstruction;

    /** @ngInject */
    public constructor() {
    }

    public $onChanges(changes: IOnChangesObject): void {
    }

    public pricingInstructionChanged(pricingInstruction: PricingInstruction) {
        this.onChange({pricingInstruction});
    }
}

const template = `
    <div class="row form-group">
        <label class="col-xs-12 col-sm-3 col-md-2 control-label" translate="order.PRICING_INSTRUCTION"></label>
        <div class="col-xs-12 col-sm-9 col-md-10">
            <select class="form-control select-pricing-instruction" ng-model="ctrl.pricingInstruction" ng-change="ctrl.pricingInstructionChanged(ctrl.pricingInstruction)">
                <option value="LIMIT" translate="order.LIMIT"></option>
                <option value="MARKET_TO_LIMIT" translate="order.MARKET_TO_LIMIT"></option>
            </select>
        </div>
    </div>
`;
